import { Alert } from '@mantine/core';

type CacheBypassNoticeProps = {
  enabled: boolean;
};

const CacheBypassNotice = ({ enabled }: CacheBypassNoticeProps) => {
  if (!enabled) {
    return null;
  }

  return (
    <Alert color="yellow" title="Cached results will be bypassed">
      Cached results will not be reused for work scheduled by this run. This may run more work and take longer.
    </Alert>
  );
};

export default CacheBypassNotice;
